import api from "./axiosInstance";

//const API_URL = "http://localhost:5000/api/parents/register";

export const registerParent = (data) => {
  return api.post(`/parents/register`, data);
};

// For parents who already have a session (signed up via Google/Apple) and
// are completing their profile — attaches to the logged-in account instead
// of registering a brand-new one.
export const completeParentProfile = (data) => {
  return api.post(`/parents/complete-profile`, data);
};

export const parentLogin = (data) => {
  return api.post(`parents/login`, data);
};

export const parentForgotPassword = (email) => {
  return api.post(`/parents/forgot-password`, { email });
};

export const verifyResetCode = (email, code) => {
  return api.post(`/parents/verify-reset-code`, { email, code });
};
export const resetParentPassword = (email, code, newPassword) => {
  return api.post(`/parents/reset-password`, { email, code, newPassword });
};
export const getParentProfile = () => {
  return api.get("/parents/profile");
};
export const getChildren = () => {
  return api.get("/parents/children");
};
export const getGuardianInfo = () => {
  return api.get("/parents/guardians");
};

export const getFullParentProfile = () => {
  return api.get("/parents/full-profile");
};

export const updateParentDetails = (id, data) => {
  return api.put(`/parents/parent-details/${id}`, data);
};

export const updateChildDetails = (childId, data) => {
  return api.put(`/parents/children/${childId}`, data);
};

export const addChild = (data) => {
  return api.post(`/parents/children`, data);
};

export const changeParentPassword = (data) => {
  return api.put("/parents/change-password", data);
};

export const getProgramEnrollments = (parentId) => {
  return api.get(`/parents/program-enrollments/${parentId}`);
};

export const deleteParentAccount = () => {
  return api.delete("/parents/account");
};

export const parentSocialLogin = (idToken, provider) => {
  return api.post(`/parents/social/${provider}`, { idToken });
};
